
import React, { useRef, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { ClickAwayListener, Grow, MenuList, Paper, Popper } from '@material-ui/core';
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";

const ColumnDropdown = ({ columns, onDragEnd, handleCheckBoxChange, handleColumnSave, btnClass }) => {
    const useStyles = makeStyles(theme => ({
        fab: {
            position: "fixed",
            right: theme.spacing(1),
            bottom: theme.spacing(3)

        },
        editfab: {
            right: theme.spacing(7),
            position: 'absolute',
        },
        paper: {
            width: 200,
            height: 230,
            overflow: 'auto',
        },
        tab: {
            minWidth: 200,
            width: 200,
        },
        search: {
            position: "relative",
            borderRadius: theme.shape.borderRadius,
            // backgroundColor: fade(theme.palette.common.white, 0.15),
            // "&:hover": {
            //     backgroundColor: fade(theme.palette.common.white, 0.25)
            // },
            marginLeft: 0,
            width: "100%",
            [theme.breakpoints.up("sm")]: {
                marginLeft: theme.spacing(1),
                marginTop: theme.spacing(30),
                width: "auto"
            }
        },
        searchIcon: {
            width: theme.spacing(7),
            height: "100%",
            position: "absolute",
            pointerEvents: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        inputRoot: { color: "inherit" },
        inputInput: {
            padding: theme.spacing(1, 1, 1, 7),
            transition: theme.transitions.create("width"),
            width: "100%",
            [theme.breakpoints.up("sm")]: {
                width: 120,
                "&:focus": {
                    width: 200
                }
            }
        }

    }));
    const classes1 = useStyles;
    const op = useRef(null);

    const [openNotification, setOpenNotification] = useState(null);

    const grid = 4;

    const getItemStyle = (isDragging, draggableStyle) => ({
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,
        ...draggableStyle
    });

    return (
        <>
            <Button type="button" icon={btnClass?'pi pi-filter' : ''} rounded={btnClass} className={btnClass ? btnClass : 'add-btn1'} onClick={(e) => {
                // op.current.toggle(e);
                if (openNotification && openNotification.contains(e.target)) {
                    setOpenNotification(null)
                } else {
                    setOpenNotification(e.currentTarget)
                }
            }}>{btnClass?null:<i className='pi pi-filter' />}</Button>
            <div className="header-bar">
                <div className="right-nav-buttons p-d-flex">
                    <div>
                        <div className="noti-dropdown-outer">
                            <Popper
                                open={Boolean(openNotification)}
                                anchorEl={openNotification}
                                transition
                                disablePortal
                                placement="bottom-end"
                                className={classNames({ [classes1.popperClose]: !openNotification, [classes1.popperResponsive]: true, [classes1.popperNav]: true })}
                            >
                                {({ TransitionProps }) => (
                                    <Grow {...TransitionProps} id="notification-menu-list" >
                                        <Paper className={classes1.dropdown + " noti-container table-dd"}>

                                            <ClickAwayListener onClickAway={() => setOpenNotification(null)}>
                                                <div>
                                                    <MenuList role="menu" className='dd-ul'>
                                                        <DragDropContext onDragEnd={onDragEnd}>
                                                            <Droppable droppableId="droppable">
                                                                {(provided, snapshot) => (
                                                                    <div
                                                                        {...provided.droppableProps}
                                                                        ref={provided.innerRef}
                                                                    >
                                                                        {columns?.map((option, index) => (
                                                                            <Draggable key={option?.id} draggableId={option?.id?.toString()} index={index}>
                                                                                {(provided, snapshot) => (
                                                                                    <div
                                                                                        className='flex items-center justify-left gap-2'
                                                                                        ref={provided.innerRef}
                                                                                        {...provided.draggableProps}
                                                                                        {...provided.dragHandleProps}
                                                                                        style={getItemStyle(
                                                                                            snapshot.isDragging,
                                                                                            provided.draggableProps.style
                                                                                        )}
                                                                                    >
                                                                                        <Checkbox checked={option.isChecked} onChange={(e) => handleCheckBoxChange(e, index)} style={{ marginRight: 8 }} />
                                                                                        {option.header}
                                                                                    </div>
                                                                                )}
                                                                            </Draggable>
                                                                        ))}

                                                                        {provided.placeholder}
                                                                    </div>
                                                                )}
                                                            </Droppable>
                                                        </DragDropContext>
                                                    </MenuList>
                                                    <MenuList className="noti-footer">
                                                        <div>
                                                            <Button className="primary-btn" onClick={async (e) => {
                                                                await handleColumnSave(columns);
                                                                setOpenNotification(null);
                                                            }}> Save</Button>
                                                        </div>

                                                    </MenuList>
                                                </div>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </div>
                    </div>
                </div>
            </div>
            {/* <OverlayPanel ref={op} className='overlay-common' closeOnEscape dismissable={true}>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {columns?.map((option, index) => (
                                    <Draggable key={option?.id} draggableId={option?.id?.toString()} index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                className='flex items-center justify-left gap-2'
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}
                                            >
                                                <Checkbox checked={option.isChecked} onChange={(e) => handleCheckBoxChange(e, index)} style={{ marginRight: 8 }} />
                                                {option.header}
                                            </div>
                                        )}
                                    </Draggable>
                                ))}

                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>

                <Button type="button" className='add-btn add-btn p-button p-component p-jc-center p-w-100' label="Save Column" onClick={(e) => handleColumnSave(columns)} />
            </OverlayPanel> */}
        </>

    );
};

export default ColumnDropdown;

